import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginLogoComponent } from './login-logo.component';

@NgModule({
  declarations: [LoginLogoComponent], 
  imports: [CommonModule], 
  exports: [LoginLogoComponent], 
})
export class LoginLogoModule {}



// WEBPACK FOOTER //
// ./ts/app/header/login-logo/login-logo.module.ts